export const handleDownloadCSV = (headers,rows,name) => {

  
  const csvRows = rows.map((row, index) => {
    return [
      index + 1, //index
      row.item_code || row.item?.item_code || "", //itemcode
      row.item?.item_name || "", //itemname
      row.item?.item_group || "", //item group || category
      row.item?.custom_category || "", // item sub category
      row.quantity || "", // item quantity
      row.item?.selling_price || "", // item selling_price
      row.uom || row.item?.stock_uom || "" ,//item uom
      String((row.quantity) * parseFloat(row.item?.selling_price)) || "0" //Amount
    ];
  });

  const csvContent = [
    headers.join(","),
    ...csvRows.map(row => row.join(","))
  ].join("\n");

  // Create download link
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.setAttribute("hidden", "");
  link.setAttribute("href", url);
  const filename = name ? `${name}.csv` : "purchase_order_items.csv";
   link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
